import { createBuffer } from "./buffer";

const algorithm: AlgorithmIdentifier = "AES-GCM";

export const getCryptoKey = (plaintextDataKey: string): Promise<CryptoKey> => {
    const bufferSource = createBuffer(plaintextDataKey, "base64");
    return crypto.subtle.importKey("raw", bufferSource, algorithm, true, ["decrypt", "encrypt"]);
};

interface CryptoData {
    cryptoKey: CryptoKey;
    data: string;
    context: string;
}

export const encryptWithCryptoKey = async ({
    cryptoKey,
    data,
    context,
    ivBuffer,
}: CryptoData & { ivBuffer: ArrayBuffer }): Promise<ArrayBuffer> => {
    const dataBuffer = createBuffer(data, "utf8");
    const contextBuffer = createBuffer(context, "utf8");

    return await crypto.subtle.encrypt(
        {
            name: algorithm,
            iv: ivBuffer,
            additionalData: contextBuffer,
        },
        cryptoKey,
        dataBuffer,
    );
};

export const decryptWithCryptoKey = ({
    cryptoKey,
    data,
    context,
    iv,
}: CryptoData & { iv: string }): Promise<ArrayBuffer> => {
    const dataBuffer = createBuffer(data, "base64");
    const contextBuffer = createBuffer(context, "utf8");
    const ivBuffer = createBuffer(iv, "base64");

    return crypto.subtle.decrypt(
        {
            name: algorithm,
            iv: ivBuffer,
            additionalData: contextBuffer,
        },
        cryptoKey,
        dataBuffer,
    );
};
